// extracted by mini-css-extract-plugin
module.exports = {"spm-menu-line-item-title":"Span_spm-menu-line-item-title__1ahNG","shimmer":"Span_shimmer__2L5N_","menuLineItemSmall":"Span_menuLineItemSmall__2dUb0"};